import httpClient from '../../httpClient';
import { DataRoomMember } from 'router/subrouters/DataRoom/models/DataRoomMember';

function updateMemberDocuments(
  memberId: string,
  data: {
    changedPermissions?: {
      dataRoomNodeId: string;
      enable: boolean;
    }[];
  },
) {
  return httpClient.patch<{ dataRoomMember: DataRoomMember }>(
    `data-room-members/${memberId}`,
    data,
  );
}

export default {
  updateMemberDocuments,
};
